import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    label?: string;
    placeholder?: string;
    selectedItems: AutoCompleteDataModel[];
    error?: boolean;
    helperText?: React.ReactNode;
    multiSelect?: boolean;
    disabled?: boolean;

    onChange: (item: AutoCompleteDataModel[]) => void;
    onError: (error: any) => void;
}


////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de calendários de feriados
 * @param props
 */
export const CalendarAutoComplete: React.FC<IProps> = (props) => {

    const api = useCoreApi();

    const {
        label, error, helperText, placeholder, selectedItems, onChange, onError,
        multiSelect = false,
        disabled = false
    } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.calendars({
                searchText: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items as AutoCompleteDataModel[],
                        totalRows: result.data.totalRows
                    });
                })
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        onError(error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            label={label ?? ""}
            multiSelect={multiSelect}
            placeholder={placeholder}
            selectedItems={selectedItems}
            onGetSuggestions={getSuggestions}
            onChange={onChange}
            disabled={disabled}
            error={error}
            helperText={helperText}
        />
    );
};
